<!-- Start -->
<app-navbar></app-navbar>
<div class="page-title-area page-title-bg1 upper-margin">
    <div class="container">
        <div class="page-title-content">
            <br />
            <br />
            <h2>{{'Order_Tracking' | translate }}</h2>

            <!--<a routerLink="/">{{'Home' | translate }}</a>-->
        </div>
    </div>
</div>
<!-- End -->
<!-- Start Order Tracking Area -->
<section class="order-tracking-area ptb-100">
    <div class="container">
        <div class="order-tracking-content">

            <h3>{{'Dear' | translate }}, {{ clientName }}</h3>
            <p>{{'Your_Order_is' | translate }} <b>{{ orderStatus }}</b></p>




        </div>
    </div>
</section>

<section class="order-tracking-area ptb-100">
    <div class="container">
        <div class="order-tracking-content">

            <h3>{{'Order_Details' | translate }}</h3>
            <p>{{'Order_No' | translate }}: <b>{{ orderNos }}</b></p>
            <p>{{'Receiver_Name' | translate }}: <b>{{ receiverName }}</b></p>
            <p>{{'Receiver_Phone_No' | translate }}: <b>{{ receiverPhoneNo }}</b></p>
            <p>{{'Delivery_Details' | translate }}: <b>{{ deliveryDetails }}</b></p>




        </div>
    </div>
</section>
<!--  End Order Tracking Area -->
